import { call, put, select } from 'redux-saga/effects';

import { goToAlertsSettingService } from './router';
import {
  createAlertSettingRequest,
  deleteAlertSettingRequest,
  updateAlertSettingRequest,
} from '../requests';
import { pathSelector } from '../../../selectors';
import { createAlertSetting, deleteAlertSetting, updateAlertSetting } from '../../../actions';

export function* createAlertSettingService(data) {
  yield put(createAlertSetting(data));

  const { success } = yield call(createAlertSettingRequest, data);

  if (success) {
    yield call(goToAlertsSettingService);
  }
}

export function* updateAlertSettingService(id, data) {
  yield put(updateAlertSetting(id, data));
  yield call(updateAlertSettingRequest, id, data);
}

export function* updateCurrentAlertSettingService(data) {
  const { alertSettingId } = yield select(pathSelector);

  yield call(updateAlertSettingService, alertSettingId, data);
}

export function* deleteAlertSettingService(id) {
  const { alertSettingId } = yield select(pathSelector);

  if (id === alertSettingId) {
    yield call(goToAlertsSettingService);
  }

  yield put(deleteAlertSetting(id));
  yield call(deleteAlertSettingRequest, id);
}

export function* deleteCurrentAlertSettingService() {
  const { alertSettingId } = yield select(pathSelector);

  yield call(deleteAlertSettingService, alertSettingId);
}
